export default "__VITE_ASSET__D7jFl$p4__"